function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangularPrism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.97 2.75a.5.5 0 0 0-.21.063L4.787 8.296a.5.5 0 0 0-.008.004l-.02.011a.5.5 0 0 0-.193.19l-3 5.25a.5.5 0 0 0 .182.68l6 3.5a.5.5 0 0 0 .492.006l.006-.004a.5.5 0 0 0 .025-.014l9.97-5.483a.5.5 0 0 0 .232-.6l-3-8.75a.5.5 0 0 0-.502-.337zm-.25 1.225 2.67 7.789-9.11 5.011-2.67-7.79 9.11-5.01zM4.886 9.957l2.207 6.436-4.412-2.575 2.205-3.861z",
    style: {
      fill: "#222",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0
    },
    id: "layer1"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangularPrism);
export default __webpack_public_path__ + "static/media/triangularPrism.21aa2c2427c1b58426749f23f44dc3fa.svg";
export { ForwardRef as ReactComponent };